import { Reveal } from "./Reveal";

export default function Schwerfallen() {
  return (
    <section data-testid="schwerfallen-section" className="bg-shell px-6 md:px-14 py-20 md:py-28">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <h2 className="font-serif tracking-tight text-2xl md:text-4xl leading-tight text-espresso">
            Dein Verstand hat es verstanden.<br />Aber dein Inneres reagiert noch.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-10 text-base md:text-lg font-light leading-relaxed text-taupe">
            Vielleicht hast du dir schon oft gesagt: «Es ist vorbei.» «Ich kann es
            nicht mehr ändern.» «Ich möchte endlich nach vorne schauen.»
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Und trotzdem ist dieses Gefühl manchmal wieder da.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Denn unser Erleben besteht nicht nur aus bewussten Gedanken. Erfahrungen
            können mit Gefühlen, Überzeugungen und automatischen Reaktionsmustern
            verbunden sein.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Deshalb kann etwas im Kopf längst abgeschlossen sein – und sich innerlich
            trotzdem noch nicht abgeschlossen anfühlen.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-12 border-l-2 border-gold pl-6 md:pl-8">
            <p className="font-serif italic text-xl md:text-2xl leading-snug text-espresso tracking-tight">
              Du musst nicht noch mehr darüber nachdenken.
            </p>
            <p className="mt-4 text-base md:text-lg font-light leading-relaxed text-taupe">
              Loslassen darf mehr sein als ein Gedanke. Es darf zu einer inneren
              Erfahrung werden.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
